module.exports = __webpack_public_path__ + "fonts/SuisseIntlCondensed-Semibold.0343fb4.woff2";